// PPS CRM - Auth Store (Zustand)
import { create } from 'zustand';
import { api } from '../lib/api';

interface User {
  id: string;
  email: string;
  role: 'OWNER' | 'MANAGER' | 'AGENT';
  fullLegalName: string;
  agentCode?: string;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,

  login: async (email: string, password: string) => {
    const response = await api.post('/api/auth/login', { email, password });
    const { accessToken, user } = response.data;
    
    localStorage.setItem('accessToken', accessToken);
    
    set({ user, accessToken, isAuthenticated: true });
  },

  logout: async () => {
    try {
      await api.post('/api/auth/logout');
    } catch (e) {
      // Ignore logout errors
    }
    localStorage.removeItem('accessToken');
    set({ user: null, accessToken: null, isAuthenticated: false });
  },

  checkAuth: async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      set({ isAuthenticated: false });
      return;
    }
    
    try {
      const response = await api.get('/api/users/me');
      set({ user: response.data, accessToken: token, isAuthenticated: true });
    } catch (e) {
      localStorage.removeItem('accessToken');
      set({ user: null, accessToken: null, isAuthenticated: false });
    }
  },
}));
